import SerialNumTable from "./serialNumTable.container";

export default SerialNumTable;
